import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';

export const AISuggestionBanner = ({ onGenerateSuggestion, isLoading = false, disabled = false, tooltipText = '' }) => {
  const { t } = useTranslation();
  const [hasGenerated, setHasGenerated] = useState(false);

  const handleGenerate = () => {
    if (isLoading || disabled) return;
    setHasGenerated(true);
    onGenerateSuggestion?.();
  };

  const actionLabel = hasGenerated ? t('ai_suggestion_banner.regenerate_suggestion') : t('ai_suggestion_banner.generate_suggestion');
  const bannerText = hasGenerated
    ? t('ai_suggestion_banner.banner_text_regenerate')
    : t('ai_suggestion_banner.banner_text_generate');

  const handleKeyDown = (e) => {
    if (disabled) return;
    if (e.key !== 'Tab' || isLoading) return;
    e.preventDefault();
    handleGenerate();
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isLoading, disabled]);

  return (
    <div className={`${styles.banner} ${disabled ? styles.disabled : ''}`} title={disabled ? tooltipText : ''}>
      <div className={styles.leftSection}>
        {isLoading ? (
          <>
            <span className={styles.loadingSpinner} />
            <span className={styles.loadingText}>{t('ai_suggestion_banner.loading')}</span>
          </>
        ) : (
          <>
            <svg className={styles.icon} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.63542 14C6.50174 13.2101 6.1493 12.3594 5.57812 11.4479C5.00694 10.5243 4.19271 9.66753 3.13542 8.8776C2.09028 8.08767 1.04514 7.58333 0 7.36458V6.59896C1.03299 6.3559 2.02344 5.90625 2.97135 5.25C3.93142 4.5816 4.73351 3.77951 5.3776 2.84375C6.03385 1.88368 6.45312 0.935763 6.63542 0H7.40104C7.51042 0.607638 7.72917 1.23351 8.05729 1.8776C8.38542 2.50955 8.80469 3.11719 9.3151 3.70052C9.83767 4.2717 10.421 4.78819 11.0651 5.25C12.0252 5.93055 13.0035 6.38021 14 6.59896V7.36458C13.3316 7.49826 12.6389 7.7717 11.9219 8.18489C11.217 8.59809 10.5608 9.09028 9.95312 9.66146C9.34549 10.2205 8.84722 10.8099 8.45833 11.4297C7.88715 12.3411 7.53472 13.1979 7.40104 14H6.63542Z" fill="#BC00EE"/>
            </svg>
            <span className={styles.label}>{t('ai_suggestion_banner.label')}</span>
            <span className={styles.text}>{bannerText}</span>
          </>
        )}
      </div>
      <div className={styles.rightSection}>
        <button
          type="button"
          className={`${styles.generateButton} ${isLoading ? styles.generateButton_loading : ''} ${disabled ? styles.generateButton_disabled : ''}`}
          onClick={handleGenerate}
          disabled={isLoading || disabled}
          title={disabled ? tooltipText : ''}
        >
          <svg
            className={styles.generateIcon}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.65 6.35C16.2 4.9 14.21 4 12 4C7.58 4 4.01 7.58 4.01 12C4.01 16.42 7.58 20 12 20C15.73 20 18.84 17.45 19.73 14H17.65C16.83 16.33 14.61 18 12 18C8.69 18 6 15.31 6 12C6 8.69 8.69 6 12 6C13.66 6 15.14 6.69 16.22 7.78L13 11H20V4L17.65 6.35Z"
              fill="currentColor"
            />
          </svg>
          <span className={styles.generateLabel}>{actionLabel}</span>
          <span className={styles.tabBadge}>Tab</span>
        </button>
      </div>
    </div>
  );
};
